import WindowSizeHOC from '@sophocles/components/WindowSizeHOC/WindowSizeHOC';

export default WindowSizeHOC;
